import { Button, InputGroup } from "react-bootstrap";
import styled from "styled-components";
import React from "react";
import { PlusLg } from "react-bootstrap-icons";

import { ButtonText } from "./Labels.tsx";

interface ButtonProps {
  icon?: any;
  label?: React.ReactNode;
  onClick?: () => void;
}

interface ActionButtonProps {
  width?: React.CSSProperties["width"];
  backgroundColor?: React.CSSProperties["backgroundColor"];
  margin?: React.CSSProperties["margin"];
}

const IconButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin: 10px;
  cursor: pointer;

  &:hover {
    background-color: var(--color-button-bg);
    border-color: none;
    border-radius: 25%;
  }

  svg {
    color: var(--color-text-primary);
  }

  &:hover svg {
    color: var(--color-primary);
  }

  p {
    color: var(--color-text-primary);
  }

  &:hover p {
    color: var(--color-primary);
  }
`;

const AddButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 50px;
  border-radius: 10px;
  box-shadow: 0px 1px 3px 0px #0000004d;
`;

const AddButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor: pointer;
  background-color: var(--color-add-button-bg);
  border-radius: 25%;

  margin: 0px;

  @media (min-width: 768px) {
    margin: 10px;
  }

  svg {
    color: var(--color-text-primary);
  }

  &:hover svg {
    color: var(--color-primary);
  }
`;

export const ActionButton = styled(Button)<ActionButtonProps>`
  width: ${(props) => props.width || "100%"};
  background-color: ${(props) => props.backgroundColor || "#1a9f47"};
  border-color: ${(props) => props.backgroundColor || "#1a9f47"};
  color: #ffffff;
  border-radius: 40px;
  font-family: "Inter";
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin: ${(props) => props.margin || "0 0 1rem 0"};
  &:hover {
    color: #ffffff;
    background-color: ${(props) => props.backgroundColor || "#1a9f47"};
    border-color: ${(props) => props.backgroundColor || "#1a9f47"};
  }
`;

export const ShowPasswordButton = styled(InputGroup.Text)`
  background-color: var(--color-button-bg);
  max-height: 58px;
`;

export const IconButton: React.FC<ButtonProps> = ({ icon, label, onClick }) => {
  return (
    <IconButtonContainer onClick={onClick}>
      {icon}
      <ButtonText>{label}</ButtonText>
    </IconButtonContainer>
  );
};

export const AddButton: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <AddButtonWrapper onClick={onClick}>
      <AddButtonContainer className="addButton">
        <PlusLg />
      </AddButtonContainer>
    </AddButtonWrapper>
  );
};

export const NewProjectButton = styled.button`
  border-radius: 15px;
  background-color: var(--color-primary);
  box-shadow: 0px 4px 8px 3px #00000026;
  box-shadow: 0px 1px 3px 0px #0000004d;
  border: none;
  padding: 5px 30px;
  color: var(--color-text-primary);
  border: 1px solid var(--color-text-primary);
  font-family: "Inter";
`;
